import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { OrderBillDetailsBus } from '@app/cp/shared/models/OrderBillDetailsBus';
import { BaseGridEditAllLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-alllines.component';
import { OrderBillUIParam } from '@app/cp/shared/models/OrderBillUIParam';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { IFeatureFlagSet } from '../../../../../shared/decorators/featureflags/featureflagset-decorator';

@Component({
    selector: 'order-bill-detail-items',
    templateUrl: './order-bill-detail-items.component.html',
    styleUrls: ['./order-bill-detail-items.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderBillDetailItemsComponent extends BaseGridEditAllLinesComponent<OrderBillDetailsBus, null, OrderService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe(data => {
            this.compFeatureFlagSet = data;
        });
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillDetailsBus";
        this.appCode = "OrderBillDetails";
    }
    @Input() set amountEntered(value) {
        if (value != this._amountEntered) {
            this._amountEntered = value;
            this.quantityValueChanged(null, null, null);
        }
    };
    private subs_featureFlagSet: Subscription; //place as class variable
    _amountEntered: number
    @Output() quantityChanged: EventEmitter<OrderBillUIParam> = new EventEmitter<OrderBillUIParam>();
    total: number = 0;
    uiParam: OrderBillUIParam = new OrderBillUIParam();
    ngOnInit() {
        this.quantityBilledBlur(null, null, null);
    }
    setForm() {
        this.editForm.patchValue({
            orderBillDetailId: this.selectedData.orderBillDetailId,
            orderDetailId: this.selectedData.orderDetailId,
            orderBillId: this.selectedData.orderBillId,
            orderId: this.selectedData.orderId,
            inventoryNumber: this.selectedData.inventoryNumber,
            inventoryDesc: this.selectedData.inventoryDesc,
            totalReceived: this.selectedData.totalReceived,
            quantity: this.selectedData.quantity,
            price: this.selectedData.price,
            quantityBilled: this.selectedData.quantityBilled
        });
    }
    protected customSetEditRows(row: OrderBillDetailsBus): UntypedFormGroup {
        let form = new UntypedFormGroup({
            'orderBillDetailId': new UntypedFormControl(row.orderBillDetailId),
            'orderDetailId': new UntypedFormControl(row.orderDetailId),
            'orderBillId': new UntypedFormControl(row.orderBillId),
            'orderId': new UntypedFormControl(row.orderId),
            'inventoryNumber': new UntypedFormControl(row.inventoryNumber),
            'inventoryDesc': new UntypedFormControl(row.inventoryDesc),
            'totalReceived': new UntypedFormControl(row.totalReceived),
            'quantity': new UntypedFormControl(row.quantity),
            'price': new UntypedFormControl(row.price),
            'quantityBilled': new UntypedFormControl(row.quantityBilled)
        });
        return form;
    }

    quantityBilledBlur(e, dataItem: OrderBillDetailsBus, rowIndex) {
        this.uiParam.amountEntered = this._amountEntered;
        this.uiParam.amountCalculated = this.calculateTotal();
        this.uiParam.data = _.cloneDeep(this.gridData);
        //if we set a quantity on the lineitem, set the item's orderbillid to the parentid so it triggers the order bill validation
        this.uiParam.data.forEach(x => {
            if(x.quantity > 0) {
                x.orderBillId = this.parentId;
            }
        });
        this.quantityChanged.emit(this.uiParam);

    }
    quantityValueChanged(e, dataItem: OrderBillDetailsBus, rowIndex) {
        this.uiParam.amountEntered = this._amountEntered;
        this.uiParam.amountCalculated = this.calculateTotal();
        this.uiParam.data = _.cloneDeep(this.gridData);
        this.uiParam.detailInfoChanged = true;
        //if we set a quantity on the lineitem, set the item's orderbillid to the parentid so it triggers the order bill validation
        if (this.uiParam.data) {
            this.uiParam.data.forEach(x => {
                if (x.quantity > 0) {
                    x.orderBillId = this.parentId;
                }
            });
        }
        this.quantityChanged.emit(this.uiParam);

    }
    calculateTotal(): number {

        let tempTotal: number = 0;
        if (this.gridData) {

            for (let i = 0; i < this.gridData.length; i++) {
                if (this.gridData[i].quantityBilled !== 0) {
                    tempTotal += CommonFunctions.RoundToPrecision((this.gridData[i].quantityBilled * this.gridData[i].price), 2);
                }
            }
        }
        this.total = CommonFunctions.RoundToPrecision(tempTotal, 2);
        return CommonFunctions.RoundToPrecision(tempTotal, 2);
    }
    curId() {
        return this._parentId;
    }
    getChangedObject(dataObj: OrderBillDetailsBus) {
        let busObj: OrderBillDetailsBus = new OrderBillDetailsBus(dataObj);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    public getChanged(param: any = null): any {
        let changedData: OrderBillDetailsBus[] = [];
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if ((this.gridData[i].isUpdated || this.gridData[i].isAdded) && this.gridData[i].orderBillId === param) {
                    let dataObj = this.getChangedObject(this.gridData[i]);
                    dataObj.isUpdated = this.gridData[i].isUpdated;
                    changedData.push(dataObj);
                }
            }
        }
        return changedData;
    }

    test() {
        this.editOn();
    }
    protected removeLocal(data: OrderBillDetailsBus) {
        this.gridData = _.remove(this.gridData, function (n) {
            return n.orderDetailId !== data.orderDetailId;
        });
        this.cloneData();
    }
}
